module.exports = __webpack_public_path__ + "static/media/slider1.7df565db.png";